import { render, staticRenderFns } from "./SelectedVolunteerResult.vue?vue&type=template&id=63c57fda&scoped=true"
import script from "./SelectedVolunteerResult.vue?vue&type=script&lang=ts"
export * from "./SelectedVolunteerResult.vue?vue&type=script&lang=ts"
import style0 from "./SelectedVolunteerResult.vue?vue&type=style&index=0&id=63c57fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c57fda",
  null
  
)

export default component.exports